module.exports = __webpack_public_path__ + "static/img/case_banner_06.6d82bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_06.png
// module id = L8MB
// module chunks = 34